import { Component, Prop, State, h, Watch } from '@stencil/core';

@Component({
  tag: 'uui-simpletable',
  styleUrl: 'uui-simpletable.css',
  shadow: false,
  scoped: true
})
export class UuiSimpletable {
  @State() data: any = [];
  @Prop() tabledata: any;
  /** add zebra striping to table */
  @Prop() zebraStriping?: boolean = false;

  componentWillLoad() {
    this.data = JSON.parse(this.tabledata);
  }

  @Watch('tabledata')
  onTableDataChange() {
    this.data = JSON.parse(this.tabledata);
  }

  render() {
    const classList = this.zebraStriping ? 'uui-simple-table-wrapper zebra-striping' : 'uui-simple-table-wrapper';

    return (
      <div class={classList}>
        <table>
          <thead>
            <tr>
              {this.data.header.map((item, i) => (
                  <th key={i}>{item}</th>
              ))}
              </tr>
          </thead>
          <tbody>
            {this.data.rows.map((item, j) => (
              <tr key={j}>
                {Object.keys(item).map((key, k) => (
                  <td key={k} innerHTML={item[key]}></td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

}
